import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { Application } from '../application.model';

@JsonObject('ApplicationResultsResponse')
export class ApplicationResultsResponse extends ApiResultsResponse<Application> {

  @JsonProperty('results', [Application])
  override results: Application[] = [];
}
